// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer_container__oM5xF","heading":"VideoPlayer_heading__E8Pe+","cover":"VideoPlayer_cover__LG0V9","playButton":"VideoPlayer_playButton__WnQxv"};